const config = {
    getBasePublicUrl: () => process.env.REACT_APP_BASE_URL || "http://localhost:8080/",
    awsUrl: "https://vigo-be.s3.eu-west-1.amazonaws.com/",
    awsUrlCourier: "https://vigo-software.s3.eu-west-1.amazonaws.com/",
    KDV: 0.2, // KDV oranı %20,
    isDev: process.env.REACT_APP_ENV === "development" || process.env.NODE_ENV === "development",
    isProduction:
        process.env.REACT_APP_ENV === "production" || process.env.NODE_ENV === "production",
    defaultBlockedCourierBalance: 5000
};

export default config;
